import { render, staticRenderFns } from "./BtnApplyFilters.vue?vue&type=template&id=442e3513&"
import script from "./BtnApplyFilters.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BtnApplyFilters.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('442e3513')) {
      api.createRecord('442e3513', component.options)
    } else {
      api.reload('442e3513', component.options)
    }
    module.hot.accept("./BtnApplyFilters.vue?vue&type=template&id=442e3513&", function () {
      api.rerender('442e3513', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/lpu/components/BtnApplyFilters/BtnApplyFilters.vue"
export default component.exports